import nuskin from './namespace.js';
import './event.js';
import mktRegionMapping from './regionMapping.js';
import RunConfigService from './runConfigService.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace ConfigService
 */
var ConfigService = function () {
    var DEFAULT_CONFIG_URI = '/content/configuration/global/markets';

    var config = {},
        defaultConfig = null,
        lastUrl = '';

    var clearConfig = function () {
        config = {};
        lastUrl = '';
    };

    var getConfiguration = (url) => {
        /**
         * If this function is called again with the same url, it will just return the same configuration it loaded
         * previously. So in general, the ajax call will happen again if you change environments or countries.
         */
        if (url !== lastUrl) {
            // TODO: the synchronous approach below works for now but we really ought to return a promise and resolve upstream.
            // return await fetch(url, {
            //     method: 'GET'
            // })
            //     .then(res => res.json())
            //     .then((res) => {
            //         config = res;
            //         nuskin.configuration = config;
            //         lastUrl = url;
            //         $.setValue(nuskin.events.global.CONFIGURATION_SET);
            //     })
            //     .catch(xhr => {
            //         nuskin.configuration = null;
            //         config = {error: 'Ajax error in getting configuration: ' + url + ' with xhr: ' + JSON.stringify(xhr)};
            //         console.log("could not load market configuration! error:" + xhr);
            //         console.log("Configuration URL: " + url);
            //     });
            $.ajax({
                type: "GET",
                url: url,
                dataType: "json",
                async: false
            }).done((data) => {
                config = data;
                nuskin.configuration = config;
                lastUrl = url;
                $.setValue(nuskin.events.global.CONFIGURATION_SET);
            }).fail((xhr) => {
                nuskin.configuration = null;
                config = {error: 'Ajax error in getting configuration: ' + url + ' with xhr: ' + JSON.stringify(xhr)};
                console.log("could not load market configuration! error:" + xhr);
                console.log("Configuration URL: " + url);
            });
        }

        return config;
    };

    var getMarketUrl = function (baseUrl, country) {
        if (typeof(country) === "undefined") {
            country = "US";
        }

        // Example: http://dev.nuskin.com/content/configuration/global/markets/americas.service.US.json
        var retUrl = baseUrl;
        if (RunConfigService.getRunConfig().assessmentApp) {
            retUrl += '/';
        }
        return retUrl + DEFAULT_CONFIG_URI + '/' + mktRegionMapping[country] + '.service.' + country + '.json';
    };

    let getMeCommerceConfig = function (country) {
        let runConfig = RunConfigService.getRunConfig();
        getConfiguration(runConfig.baseUrl + '/content/configuration/global/mecommerce/' + mktRegionMapping[country] + '.service.' + country + '.json');
        return config;
    };

    let getMarketConfig = function (agelocMe, _country) {
        let country = _country,
            runConfig = RunConfigService.getRunConfig();

        if (!country) {
            country = runConfig.country;
        }

        if (!country || typeof(country) === "undefined") {
            country = "US";
        }

        if (agelocMe) {
            clearConfig();
        }

        let configUri;
        if (typeof(runConfig) !== undefined && runConfig.siteConfigurationPath !== undefined && runConfig.country === country) {
            configUri = runConfig.siteConfigurationPath;
        } else {
            runConfig.country = country;
            if (runConfig.assessmentApp) {
                // beggining slash gets stripped off during the agelocme build process.
                configUri = '/' + DEFAULT_CONFIG_URI + '/' + mktRegionMapping[country];
            } else {
                configUri = DEFAULT_CONFIG_URI + '/' + mktRegionMapping[country];
            }
            runConfig.siteConfigurationPath = configUri;
        }

        let configUrl,
            fixedBaseUrl;

        if (runConfig.assessmentApp) {
            if (!config.siteUrl) {
                if (defaultConfig) {
                    config = defaultConfig;
                } else {
                    // Get default config first
                    getConfiguration('content/configuration/global/markets/' + mktRegionMapping[country] + '.service.' + country + '.json');
                    if (config.siteUrl) {
                        defaultConfig = _.cloneDeep(config);
                    }
                }
            }
            fixedBaseUrl = config.siteUrl;
        } else {
            fixedBaseUrl = runConfig.baseUrl;
        }

        if (!fixedBaseUrl) {
            fixedBaseUrl = "";
        }
        if (fixedBaseUrl && (fixedBaseUrl.length > 0) && (fixedBaseUrl.charAt(fixedBaseUrl.length - 1) === '/')) {
            fixedBaseUrl = fixedBaseUrl.slice(0, fixedBaseUrl.length - 1);
        }

        configUrl = fixedBaseUrl + configUri + '.service.' + country + '.json';
        if (agelocMe) {
            configUrl += '?timestamp=' + Date.now();
        }
        getConfiguration(configUrl);
        if (config.error && defaultConfig) {
            config = nuskin.configuration = defaultConfig;
        }

        if (runConfig.assessmentApp) {
            overwriteAgelocConfig();
        }

        // Check to see if we need to do any overrides for pitch.
        if (nuskin.util.isPersonalOffer()) {
            overwriteConfigForPitchApp();
        }

        return config;
    };

    var getAgelocConfig = function (_market) {
        return getMarketConfig(true, _market);
    };

    var getUrlConfig = function (url, clearIt) {
        if (clearIt) {
            clearConfig();
        }

        return getConfiguration(url);
    };

    var setConfig = function (configObj) {
        config = configObj;

        return config;
    };

    function overwriteAgelocConfig() {
        if (config.hasOwnProperty("agelocme")) {
            // disable gigyaLogin in the app right now.  There are issues with building and iOS and stuff
            config.agelocme.override_useGigyaLogin = false;

            var agelocme = config.agelocme;
            for (var agelocProp in agelocme) {
                if (agelocme.hasOwnProperty(agelocProp)) {
                    if (agelocProp.match(/^override_/g) && agelocme[agelocProp] !== "inherit" && agelocme[agelocProp] !== "") { //override and not empty
                        var replaceProp = agelocProp.substring(9);                                                              //Strip off override_

                        // TODO: Temporary fix for AEM-11189
                        if (agelocProp === 'override_showShippingPromoCode' ||
                            agelocProp === 'override_showPaymentPromoCodeOffers' ||
                            agelocProp === 'override_showProductPromoCode') {

                            config.checkout[replaceProp] = agelocme[agelocProp];
                        } else {
                            replaceProperty(replaceProp, agelocme[agelocProp]);
                        }
                    }
                }
            }
        }
    }

    function overwriteConfigForPitchApp() {
        // Set overrides given it is a pictch checkout.

        // Enable Ecom3 guest checkout
        // Note: Ecom3 uses guest checkout for Pitch if we have a pitch cart. Nothing more to override here.

        // Hide promo codes. We need to hide "./checkout/showProductPromoCode" and "./checkout/showPaymentPromoCodeOffers"
        config.checkout.showProductPromoCode = false;
        config.checkout.showPaymentPromoCodeOffers = false;
    }

    function replaceProperty(replaceProp, replaceValue) {
        if (config.hasOwnProperty(replaceProp)) {
            config[replaceProp] = replaceValue;
        } else {
            for (var property in config) {
                if (config.hasOwnProperty(property)) {
                    if (property !== "agelocme" && config[property].hasOwnProperty(replaceProp)) {
                        config[property][replaceProp] = replaceValue;
                    }
                }
            }
        }
    }

    return {
        getMeCommerceConfig: getMeCommerceConfig,
        getMarketConfig: getMarketConfig,
        getAgelocConfig: getAgelocConfig,
        getUrlConfig: getUrlConfig,
        setConfig: setConfig
    }
}();

export default ConfigService;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/configurationService.js
// module id = 8
// module chunks = 0